// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"40ad8411","213":"22eb78b3","239":"8d0932de","453":"02b57734","732":"969362b6","762":"3370ac8a"}[chunkId] + ".chunk.js";
};